import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-activity',
  templateUrl: './breadcrumb-activity.component.html',
  styleUrls: ['./breadcrumb-activity.component.scss']
})
export class BreadcrumbActivityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
